import React, { FunctionComponent } from 'react';
import { DealerLaunchStepProps } from '../types';
import { TextField } from '../../Input/TextField/TextField';
import { Dealer } from '../../../types/dealerTypes';
import { emailValidatorFunction } from '../../../utils/validation';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { DealerLaunchFormCardLayout } from '../DealerLaunchFormCardLayout';

export const DealerLaunchAboutSupportEmail: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  prevStep,
  nextStep,
}) => {
  const form = useLaunchpadForm<Dealer>({ defaultValues: dealer });

  return (
    <DealerLaunchFormCardLayout
      form={form}
      title="How can online shoppers get in touch with you?"
      subTitle="If a customer who has built an online deal has any questions, what email address should they contact?"
      cardTitle="Contact Information For Customer Inquiries"
      prevStep={prevStep}
      onFormSubmit={nextStep}
    >
      <TextField
        label="Customer Inquiries Email"
        tooltip="Use an email that is actively monitored, do not use a CRM address."
        name="supportEmail"
        width="md"
        form={form}
        validation={{ required: true, validate: emailValidatorFunction }}
      />
    </DealerLaunchFormCardLayout>
  );
};
